import { usePrintsConfigStore, usePrintsUiStore } from '../stores';
import { selectAvailableSizesForDeliveryAndFinish } from '../stores/selectors';

export const useAvailableSizesForSelectedDeliveryAndFinish = () => {
  const allSizes = usePrintsConfigStore((state) => state.allSizes);
  const selectedDeliveryKey = usePrintsUiStore(
    (state) => state.selectedDeliveryKey,
  );
  const selectedFinishName = usePrintsUiStore(
    (state) => state.selectedFinishName,
  );

  return selectAvailableSizesForDeliveryAndFinish(
    allSizes,
    selectedDeliveryKey,
    selectedFinishName,
  );
};
